import React from 'react';
import {
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  Paper,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
} from '@material-ui/core';
import { Add, Search, Edit, RemoveRedEye, DeleteForever } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import withRoot from '../../withRoot';
import fetchData from '../../utils/fetch';
import Loader from '../../components/loader';
import { Link, Route } from 'react-router-dom';
import history from '../../utils/history';
import { find } from 'lodash';
import ItemView from './item';
import ItemEdit from './item-edit';
import 'url-search-params-polyfill';
import { I18n } from '../../i18n/';
import TablePaginationActions from '../../components/pagination/CustomPagination';

const styles = theme => ({
  root: {
    textAlign: 'left',
    width: '94%',
    margin: '30px 3%',
  },
  pagination: {
    marginTop: 20,
    color: '#BDBEC0',
    '& div:first-child': {
      display: 'flex',
      'flex-direction': 'column',
      'align-items': 'center',
    }
  },
  paper: {
    overflowX: 'auto',
    boxShadow: 'none',
  },
  table: {
    maxWidth: '100%',
    minWidth: 700,
    textAlign: 'center',
    '& tbody tr': {
      verticalAlign: 'top'
    },
    '& tbody td': {
      paddingTop: '10px',
      fontSize: '1rem',
      color: '#191970',
    }
  },
  alignRight: {
    textAlign: 'right'
  },
  textField: {
    width: '100%',
    marginBottom: '20px'
  },
  actions: {
    whiteSpace: 'nowrap',
    '& a': {
      display: 'inline-flex',
      color: '#fff',
      fontSize: '12px',
      lineHeight: '25px',
      alignItems: 'center',
      backgroundColor: '#6495ed',
      padding: '0 8px',
      '&:first-child': {
        backgroundColor: '#add8e6',
        borderRadius: '3px 0 0 3px'
      },
      '&:last-child': {
        backgroundColor: '#fe8368',
        borderRadius: '0 3px 3px 0'
      }
    },
    '& svg': {
      width: '15px',
      height: '15px',
      marginRight: '2px'
    }
  }
});

const tableTitles = [
  {id: 'id', title: 'ID'},
  {id: 'createdAt', title: 'Created At'},
  {id: 'nameUa', title: 'Name UA'},
  {id: 'nameEn', title: 'Name EN'},
  {id: 'updatedAt', title: 'Updated At'}
];

class EuropeActions extends React.Component {
    state = {
      loading: true,
      items: [],
      page: 0,
      total: 0,
      rowsPerPage: 25,
      searchQuery: '',
      order: 'desc',
      orderBy: ''
    };
    componentDidMount() {
      const query = new URLSearchParams(document.location.search);
      const search = query.get('search');
      if (search) {
        this.setState({ searchQuery: search });
        this.getSearchResults(search);
      } else {
        this.getData();
      }
    }

    async getData() {
      const data = await fetchData('get', '/europe_actions');
      this.setState({ loading: false, items: await data[0], total: data[1] });
    }

    async deleteItem(id) {
      const {lang} = this.props;
      if (window.confirm(`${I18n[lang].common.deleteConfirm} ${I18n[lang].europeActions.europeAction} ${id}?`)) {
        await fetchData('delete', `/europe_actions/${id}`);
        this.getData();
      }
    }

    handleChangePage = (event, page) => {
      this.getPage(page);
      this.setState({ loading: true, page: page });
      history.push({
        search: `?page=${page}`
      })
    }

    async getPage(pageNumber) {
      const data = await fetchData('get', `/europe_actions?page=${pageNumber + 1}`);
      this.setState({ loading: false, items: await data[0] });
    }

    viewItem = ({ match: { params: { id } } }) => {
      if (this.state.loading) return null;
      const item = find(this.state.items, { id: Number(id) });

      return <ItemView item={item}  lang={this.props.lang} />;
    }

    editItem = ({ match: { params: { id } } }) => {
      if (this.state.loading) return null;
      const item = find(this.state.items, { id: Number(id) });

      return <ItemEdit item={item} handleItemSave={this.handleItemSave} lang={this.props.lang} />;
    }

    handleChangeRowsPerPage = event => {
      this.setState({ rowsPerPage: event.target.value });
    }

    async getSearchResults(searchQuery) {
      const data = await fetchData('get', `/_search/europe_actions?query=${searchQuery}`);
      this.setState({ loading: false, items: await data[0], total: data[1] });
    }

    updateInputValue = e => this.setState({ searchQuery: e.target.value });

    handleSubmit = (e) => {
      e.preventDefault();
      this.setState({ loading: true });
      const search = this.state.searchQuery;
      this.getSearchResults(search);

      history.push({
        search: `?search=${this.state.searchQuery}`
      })
    }

    handleSort = orderBy => event => {
      let order = 'desc';
      if (this.state.orderBy === orderBy && this.state.order === 'desc') {
        order = 'asc';
      }
      this.setState({ loading: true, orderBy: orderBy, order: order });
      this.getSort(orderBy, order);

      history.push({
        search: `?sort=${orderBy},${order}`
      })

    }

    async getSort(orderBy, order) {
      const data = await fetchData('get', `/europe_actions?sort=${orderBy},${order}`);
      this.setState({ loading: false, items: await data[0] });
    }

    handleItemSave = () => {
      this.setState({ loading: true });
      this.getData();
    }

    render() {
        const { classes, match, lang } = this.props;
        const { items, page, rowsPerPage, total, order, orderBy } = this.state;
        return (
          <div className={classes.root}>
            {this.state.loading && (
              <Loader />
            )}
            <Grid container spacing={24} alignItems='center'>
              <Grid item xs={6}>
                <Typography gutterBottom variant="h2" component="h2" style={{'color': '#fdbb2d'}}>
                  {I18n[lang].europeActions.europeActions}
                </Typography>
              </Grid>
              <Grid item xs={6} className={classes.alignRight}>
                <Link component={Button} to={`/europe-actions/create/`}>
                  <Button variant="contained" className="btn-create" color="primary">
                    <Add />
                    {I18n[lang].europeActions.create}
                  </Button>
                </Link>
              </Grid>
            </Grid>
            <form method="get" action="" onSubmit={this.handleSubmit}>
              <TextField
                id="outlined-name"
                label={I18n[lang].europeActions.search}
                className={classes.textField}
                margin="normal"
                variant="outlined"
                name="search"
                value={this.state.searchQuery}
                onChange={this.updateInputValue}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={this.handleSubmit}
                        aria-label={I18n[lang].europeActions.search}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </form>
            <Paper className={classes.paper}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    {tableTitles.map( item => {
                      return(
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === item.id}
                            direction={order}
                            onClick={this.handleSort(item.id)}
                           >
                            {I18n[lang].common[item.id]}
                          </TableSortLabel>
                        </TableCell>
                      )
                    })}
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items
                    .map(row => {
                    return (
                      <TableRow key={row.id}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.createdAt}</TableCell>
                        <TableCell>{row.nameUa}</TableCell>
                        <TableCell>{row.nameEn}</TableCell>
                        <TableCell>{row.updatedAt}</TableCell>
                        <TableCell className='actions'>
                          <Link to={`/europe-actions/view/${row.id}`}>
                            <RemoveRedEye/>
                            <span>{I18n[lang].common.view}</span>
                          </Link>
                          <Link to={`/europe-actions/edit/${row.id}`}>
                            <Edit/>
                            <span>{I18n[lang].common.edit}</span>
                          </Link>
                          <a onClick={() => this.deleteItem(row.id)} href="#">
                            <DeleteForever/>
                            <span>{I18n[lang].common.delete}</span>
                          </a>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              <TablePagination
                className={classes.pagination}
                labelDisplayedRows={({ from, to, count }) => 
                  `Showing ${from} - ${to} of ${count} items`}
                component="div"
                count={total}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[]}
                page={page}
                onChangePage={this.handleChangePage}
                ActionsComponent = {TablePaginationActions}
              />
            </Paper>
            <Route path="/europe-actions/view/:id" render={this.viewItem} />
            <Route path="/europe-actions/edit/:id" render={this.editItem} />
            <Route path="/europe-actions/create" render={this.editItem} />
          </div>
        );
    }
}

export default withRoot(withStyles(styles)(EuropeActions));
